import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertIndicatorResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertIndicatorResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertIndicatorResultInput = {
  Description?: string | null;
  IndicatorId: string;
  ResultDate: string;
  TargetValueNum?: number | null;
  TargetValueTxt?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertIndicatorResult = createMutationHook({
  name: 'insertIndicatorResult',
  isIdempotentCreate: true,
  idempotencyScope: (input: InsertIndicatorResultInput) => input.IndicatorId,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.indicator.insertResult.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (input: InsertIndicatorResultInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.indicator.indicatorResultsByIndicatorId.queryKey(),
    // COI-889: the indicator register and the risk/control Indicators tabs
    // read latest/previous result and conformance off this router.
    trpc.frontend.indicator.pathKey(),
  ],
  mapResponse: (result: { Id: string }): InsertIndicatorResultMutation => ({
    insert_indicator_result_one: {
      __typename: 'indicator_result',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertIndicatorResultDocument,
  graphqlVariables: (input: InsertIndicatorResultInput) => ({ ...input }),
  evictFields: ['indicator_result', 'indicator'],
});
